import { Injectable } from '@angular/core';
import * as countries from 'i18n-iso-countries';
import { SelectItem } from 'primeng/select';
import { PositizeService } from './positize.service';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private nationalities: { [key: string]: string } = {};

  constructor(private positizeService: PositizeService) {}

  getDefaultCountryCode(): string {
    return this.positizeService.shopConfig.defaultCountryCode;
  }

  async loadLocale(): Promise<void> {
    let language = this.positizeService.language;
    try {
      const response = await fetch(
        `assets/i18n-iso-countries/langs/${language}.json`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const localeModule = await response.json();
      countries.registerLocale(localeModule);
      console.log(`Locale ${language} loaded successfully.`);
    } catch (error) {
      console.error(`Failed to load locale for language: ${language}`, error);
      const fallbackResponse = await fetch(
        `assets/i18n-iso-countries/langs/en.json`
      );
      const fallbackLocaleModule = await fallbackResponse.json();
      countries.registerLocale(fallbackLocaleModule);
    }
  }

  async loadNationalities(): Promise<void> {
    const language = this.positizeService.language;
    try {
      const response = await fetch(`assets/nationalities/${language}.json`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      this.nationalities = await response.json();
    } catch (error) {
      console.error(`Failed to load nationalities for: ${language}`, error);
      const fallback = await fetch('assets/nationalities/en.json');
      this.nationalities = await fallback.json();
    }
  }

  getCountrySelectItems(): SelectItem[] {
    const countries = this.getCountries();
    let items = [];

    for (const code in countries) {
      items.push({ label: countries[code], value: code });
    }
    return items;
  }

  getNationalitySelectItems(): SelectItem[] {
    const items = [];
    for (const code in this.nationalities) {
      items.push({ label: this.nationalities[code], value: code });
    }
    items.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
    return items;
  }

  getNationalityName(code: string): string {
    if (!code) return '';
    return this.nationalities[code] || this.getCountryName(code);
  }

  getCountries(): { [key: string]: string } {
    return countries.getNames(this.positizeService.language);
  }

  getCountryName(code: string): string {
    return countries.getName(code, this.positizeService.language) || 'Unknown';
  }
}
